/** @format */

import {ROUTES} from 'constants/ROUTES';
import Breadcrumbs from 'components/Breadcrumbs';

interface FullAiReportBreadcrumbsProps {
  reportDate: string;
  companyName: string;
}

const FullAiReportBreadcrumbs = ({companyName, reportDate}: FullAiReportBreadcrumbsProps) => {
  const getReportName = () => {
    const date = new Date(reportDate);
    const formatted = new Intl.DateTimeFormat('ru-RU', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    }).format(date);
    return `${companyName} — Отчет ${formatted}`;
  };

  const breadcrumbs = [
    {
      href: `/${ROUTES.HOME}`,
      title: companyName,
    },
    {
      href: `/${ROUTES.AI_REPORTS_SHOW}`,
      title: getReportName(),
    },
  ];

  return <Breadcrumbs items={breadcrumbs} />;
};

export default FullAiReportBreadcrumbs;
